import {Card, CardContent, Typography} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    minWidth: 200,
    margin:5,
    padding: 5,
    boxShadow:''
  },
});

export default function CommentsCard(props){
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography variant="body2" component="p">
          {props.text}
        </Typography>
      </CardContent>
    </Card>
  );
}
